import { render, staticRenderFns } from "./Carga.vue?vue&type=template&id=e4112cfa"
import script from "./Carga.vue?vue&type=script&lang=js"
export * from "./Carga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports